export default __webpack_public_path__ + "fonts/22ee4ce4bfb5997b12476296d1309cd3.svg";